import React, { useCallback, useEffect, useState } from "react";
import { useParams, withRouter } from "react-router";
import { connect } from "react-redux";
import ReactTableWrapper from "components/reacttable/reacttbl.style";
import { getCallLogByUserId } from "services/usersServices";
import NavigationActions from "redux/navigation/actions";
import { compose } from "redux";
import Loader from "components/Loader";
import Pagination from "components/common/Pagination";
// import moment from "moment";
import Logs from "./Logs";
const { success, error, fetching } = NavigationActions;

let debounceTimer;

function UserLogs(props) {
  const params = useParams();
  const userId = params.userId;
  const userName = params.userName;
  const [currentPage, setCurrentPage] = useState(0);
  const [expanded, setExpanded] = useState();
  const pageLength = 10;
  const [totalPage, setTotalPage] = useState(0);
  const { token, error, fetching } = props;
  const [refresh, toggleRefresh] = useState(false);
  const [usersList, setUsersList] = useState([]);
  const [totalRecords, setTotalRecords] = useState("0");
  const [loading, setLoading] = useState(false);
  const [searchText, setSearchText] = useState("");
  const [startDate, setStartDate] = useState(new Date("2023-01-01"));
  const [endDate, setEndDate] = useState(new Date());

  const callApi = useCallback(async () => {
    let params = {
      page: currentPage + 1,
      limit: pageLength || 10,
      startdate: new Date(startDate).toISOString(),
      enddate: new Date(endDate).toISOString(),
      search: ""
    };
    await getCallLogByUserId(token, userId, {
      params: params
    }).then(response => {
      if (response.success) {
        setUsersList(response?.data?.data);
        setTotalRecords(response?.data?.totalData);
        setTotalPage(response?.data?.totalPages);
        setLoading(false);
        toggleRefresh(false);
      } else {
        error(response.message);
      }
    });
  });

  useEffect(() => {
    if (debounceTimer) {
      clearTimeout(debounceTimer);
      debounceTimer = null;
    }
    debounceTimer = setTimeout(() => {
      callApi();
    }, 1000);
  }, [startDate, endDate]);

  useEffect(() => {
    refresh && callApi();
  }, [refresh, currentPage, pageLength]);

  const handlePageChange = page => {
    fetching();
    setCurrentPage(page);
    toggleRefresh(true);
  };

  return (
    <>
      <div className="container-fluid">
        <div className="row title-sec align-items-center">
          <div className="col-sm headline">Call Logs - {userName}</div>
          <div className="col-auto "></div>
        </div>
        <div className="row align-items-center my-3">
          <div className="col-md-4">
            <div className="icon-form-control">
              <input
                type="date"
                value={startDate}
                onChange={e => {
                  setCurrentPage(0);
                  setStartDate(e.target.value);
                }}
                max={new Date().toISOString().split("T")[0]}
                placeholder="Select Start Date"
                className="form-control log-form-control react-form-input"
              />
            </div>
          </div>
          <div className="col-md-4">
            <div className="icon-form-control">
              <input
                value={endDate}
                onChange={e => {
                  setCurrentPage(0);
                  setEndDate(e.target.value);
                }}
                type="date"
                min={startDate}
                max={new Date().toISOString().split("T")[0]}
                placeholder="Select End Date"
                className="form-control log-form-control react-form-input"
              />
            </div>
          </div>
        </div>
        <div className="div-container">
          <ReactTableWrapper {...props}>
            <div className="table-responsive common-table card-box grey-box mb-2">
              <table className="table table-bordered">
                <thead>
                  <tr>
                    <th>Date</th>
                    <th>Total Logs</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  {loading ? (
                    <tr>
                      <td colSpan={3}>
                        <Loader colspan={3} />
                      </td>
                    </tr>
                  ) : usersList?.length > 0 ? (
                    usersList.map((item, index) => (
                      <tr key={item?._id + "_" + index}>
                        <td>{new Date(item?._id)?.toDateString()}</td>
                        <td>{item?.callLogs?.length}</td>
                        <td>
                          <button
                            className="btn btn-link"
                            data-bs-toggle="collapse"
                            data-bs-target={`#collapse${index}`}
                            onClick={() => {
                              setExpanded(expanded === index ? null : index);
                            }}
                          >
                            <i
                              className={`fa ${
                                expanded === index ? "fa-eye-slash" : "fa-eye"
                              }`}
                            ></i>
                          </button>
                          <div
                            className={`collapse ${
                              expanded === index ? "show" : ""
                            }`}
                            id={`collapse${index}`}
                          >
                            <Logs callLogs={item.callLogs} />
                          </div>
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td className="td-border" colSpan={3}>
                        <h6>No Data Found</h6>
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
            <div className="row align-items-center table-footer">
              <div className="col-sm-6 text-center text-sm-left">
                <span className="total-entry">
                  Showing{" "}
                  {console.log(
                    "pagination>>>>",
                    currentPage,
                    pageLength,
                    usersList?.length,
                    totalRecords
                  )}
                  {Math.min(
                    currentPage * pageLength + usersList?.length,
                    totalRecords
                  )}{" "}
                  of {totalRecords} entries
                </span>
              </div>
              <div className="col-sm-6">
                <Pagination
                  onPageChange={handlePageChange}
                  pages={totalPage}
                  page={currentPage}
                />
              </div>
            </div>
          </ReactTableWrapper>
        </div>
      </div>
    </>
  );
}

const mapStateToProps = state => {
  return {
    ...state.themeChanger,
    token: state.auth.accessToken,
    user: state.auth.user,
    channel: state.navigation.channel
  };
};

export default compose(
  withRouter,
  connect(mapStateToProps, {
    success,
    error,
    fetching
  })
)(UserLogs);
